module.exports = __webpack_public_path__ + "static/media/bgr-gold.b35ca15f.webp";